import { useQuery } from '@tanstack/react-query';
import { MRT_ColumnFiltersState } from 'mantine-react-table';
import { useMemo } from 'react';

import { useResultsQueries } from '../data-access/queries/results';
import { getResultsSummaryFilters } from '../lib/results-stats';

export function useResultsStats(
  columnFilters: MRT_ColumnFiltersState,
  options?: { enabled?: boolean },
) {
  const resultsQueries = useResultsQueries();
  const summaryFilters = useMemo(
    () => getResultsSummaryFilters(columnFilters),
    [columnFilters],
  );

  return useQuery({
    ...resultsQueries.summary(summaryFilters),
    enabled: options?.enabled ?? true,
  });
}
